import * as yup from 'yup'

const schema = yup.object().shape({
  member: yup.string().required(),
  demoEndDate: yup.string().required(),
})

export default schema
